export interface CryptoCurrencyOptions {
  decimals: number;
  visibleDecimals: number;
  code: string;
  name: string;
  symbol: string;
  isCrypto: boolean;
  fraction?: number;
}

export const CURRENCY_OPTIONS: { [key: string]: CryptoCurrencyOptions } = {
  edg: {
    decimals: 0,
    visibleDecimals: 0,
    code: 'EDG',
    name: 'Edgeless',
    symbol: 'EDG',
    isCrypto: true,
  },
  demo: {
    decimals: 0,
    visibleDecimals: 0,
    code: 'DEMO',
    name: 'DEMO',
    symbol: 'DEMO',
    isCrypto: true,
  },
  btc: {
    decimals: 8,
    visibleDecimals: 5,
    code: 'BTC',
    name: 'Bitcoin',
    symbol: '₿',
    isCrypto: true,
  },
  ltc: {
    decimals: 8,
    visibleDecimals: 3,
    code: 'LTC',
    name: 'Litecoin',
    symbol: 'Ł',
    isCrypto: true,
  },
  eth: {
    decimals: 18,
    visibleDecimals: 4,
    code: 'ETH',
    name: 'Ethereum',
    symbol: 'Ξ',
    isCrypto: true,
  },
  usd: {
    decimals: 2,
    visibleDecimals: 2,
    code: 'USD',
    name: 'US Dollar',
    symbol: '$',
    isCrypto: false,
    fraction: 2,
  },
  eur: {
    decimals: 2,
    visibleDecimals: 2,
    code: 'EUR',
    name: 'Euro',
    symbol: '€',
    isCrypto: false,
    fraction: 2,
  },
  usdt20: {
    // dummy USD
    decimals: 6,
    visibleDecimals: 2,
    code: 'USD',
    name: 'US Dollar',
    symbol: '$',
    isCrypto: false,
    fraction: 2,
  },
  dai: {
    // dummy USD
    decimals: 6,
    visibleDecimals: 2,
    code: 'USD',
    name: 'US Dollar',
    symbol: '$',
    isCrypto: false,
    fraction: 2,
  },
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/constants.ts